const identity = v => v;

function diff(a: Array<*>, b: Array<*>, iteratee: (*) => Id = identity) {
  const set = new Set(a.map(iteratee));

  return b.reduce((acc, v) => {
    const vv = iteratee(v);
    if (!set.has(vv)) {
      acc.push(vv);
    }
    return acc;
  }, []);
}

export default function(
  current: Array<*>,
  next: Array<*>,
  iteratee: (*) => Id = identity
) {
  return {
    added: diff(current, next),
    deleted: diff(next, current),
  };
}



// WEBPACK FOOTER //
// ./src/components/ModerationCard/collectionDiff.js